<!-- Header -->
<div class="bb-page-header">
  <div class="bb-page-title-block">
    <span class="bb-eyebrow delivery-title-chip">
      <i class="fa-solid fa-truck-fast" aria-hidden="true"></i>
      {{ "delivery fees" | transloco }}
    </span>
    <h2 class="bb-page-title delivery-page-title">
      <i class="fa-solid fa-money-bill-wave" aria-hidden="true"></i>
      {{ "delivery fees" | transloco }}
    </h2>
    <p class="bb-page-subtitle">{{ "Manage delivery prices by governorate" | transloco }}</p>
  </div>
</div>

<!-- Card -->
<div class="bb-card bb-p-20">

  <!-- Form -->
  <form [formGroup]="priceForm" (ngSubmit)="addItem()" class="bb-w-100 bb-mb-16">

    <div class="bb-form-grid">

      <!-- Governorate -->
      <div class="bb-field">
        <label class="bb-label delivery-label">
          <i class="fa-solid fa-map-location-dot" aria-hidden="true"></i>
          {{ "Governorate" | transloco }}
        </label>
        <div class="bb-select-wrap">
          <select formControlName="governorate_id" class="bb-select">
            <option value="">
              {{ "Select Governorate" | transloco }}
            </option>

            <option *ngFor="let gov of governorates" [value]="gov.id">
              {{ isAr ? gov.governorate_name_ar : gov.governorate_name_en }}
            </option>
          </select>
        </div>
      </div>

      <!-- Price -->
      <div class="bb-field">
        <label class="bb-label delivery-label">
          <i class="fa-solid fa-money-bill-wave" aria-hidden="true"></i>
          {{ "delivery fees" | transloco }}
        </label>
        <input type="number" formControlName="price" class="bb-input" placeholder="0" />
      </div>

      <!-- Submit -->
      <div class="bb-field bb-field-full">
        <button class="bb-btn bb-btn-primary bb-w-100" type="submit" [disabled]="priceForm.invalid">
          <i class="fa-solid fa-plus" aria-hidden="true"></i>
          {{ "Submit" | transloco }}
        </button>
      </div>

    </div>
  </form>

  <!-- Table -->
  <div class="bb-table-scroll">
    <table mat-table [dataSource]="dataSource" class="bb-table">

      <!-- Governorate -->
      <ng-container matColumnDef="governorate">
        <th mat-header-cell *matHeaderCellDef>
          <i class="fa-solid fa-map-location-dot delivery-th-icon" aria-hidden="true"></i>
          {{ "Governorate" | transloco }}
        </th>
        <td mat-cell *matCellDef="let element">
          <i class="fa-solid fa-location-dot delivery-cell-icon" aria-hidden="true"></i>
          {{ isAr
          ? element.governorate?.governorate_name_ar
          : element.governorate?.governorate_name_en }}
        </td>
      </ng-container>

      <!-- Price -->
      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef>
          <i class="fa-solid fa-money-bill-wave delivery-th-icon" aria-hidden="true"></i>
          {{ "delivery fees" | transloco }}
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="bb-price">
            {{ element.price }} {{ 'ج.م' | transloco }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>

  <app-nodata *ngIf="noData"></app-nodata>

</div>
